import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AppConfigService } from 'src/app/app-config.service';
import { EndpointBuilderService } from 'src/app/shared/services/endpint-builder.service';
import { ApiEnum } from 'src/app/shared/enum/api.enum';
import { CommonService } from '../../common-service';
import { ListHealthUnitResponse } from '../../responses/user/list-health-unit.response';
import { ProfessionResponse } from '../../responses/user/profession.response';

@Injectable({
  providedIn: 'root'
})
export class ProfessionService extends CommonService {

  constructor(private router: Router, private httpClient: HttpClient, configService: AppConfigService, private endpointBuilder: EndpointBuilderService) {
    super(configService);
  }

  public listProfession(): Observable<ProfessionResponse> {

    let uri = `Profession`

    return this.httpClient.get<ProfessionResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiUser) + uri, this.addHeaderToken())
      .pipe(
        catchError(this.handleError)
      )
  }
}

